<app-loader [Parent]="this"></app-loader>


<div class="columns m-2">
  <div class="column is-2">
    <nav class="panel">
      <p class="panel-heading">
        Parameters
      </p>
      @for (param of Report.Parameters; track param) {
        <div class="panel-block">
          <div class="field">
            <label class="label">{{param.Description}}</label>
            <div class="control">
              @if (param.Type=='Text') {
                <input class="input" type="text" [(ngModel)]="param.Value">
              }
              @if (param.Type=='Date') {
                <input class="input" type="date" [(ngModel)]="param.Value">
              }
              @if (param.Type=='Number') {
                <input class="input" type="number" [(ngModel)]="param.Value">
              }
              @if (param.Type =='Dropdown') {
                <div class="select">
                  <select class="input" [(ngModel)]="param.Value">
                    @for (opt of param.Options; track opt) {
                      <option [ngValue]="opt.Value">{{opt.Name}}</option>
                    }
                  </select>
                </div>
              }
              @if (param.Type =='MultiSelect') {
                <div>
                  <app-dropdown-multiselector [(ngModel)]="param.Value" [Options]="param.Options"></app-dropdown-multiselector>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <div class="panel-block">
        <div class="field">
          <label class="label">Output</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select class="input" [(ngModel)]="ReportRequest.ReportTarget" style="width: 100%;" >
                <option value="BrowserReportTarget">View in Browser</option>
                <option value="PdfReportTarget">PDF</option>
                <option value="CsvReportTarget">CSV Download</option>
              </select>
            </div>
          </div>
        </div>

      </div>
      <div class="panel-block">

        <button class="button is-primary is-fullwidth" (click)="RunReport()">
          Run
        </button>
      </div>
    </nav>
  </div>
  <div class="column is-10" style="position: relative;">
    <div class="report-background">
      <div class="report-container">
        <i class="fa fa-note-sticky is-size-1"></i>
        <app-loader [Parent]="ReportLoading" Mode="cube"></app-loader>
        @if (ResultMode == 'BrowserReportTarget' && Output != null) {
          <iframe class="html-report" [srcdoc]="Output">
          </iframe>
        }
        @if (ResultMode == 'PdfReportTarget' && Output != null) {
          <iframe class="html-report" [src]="Output" >
          </iframe>
        }
      </div>
    </div>
  </div>
</div>